<template>
  <div class="log-data-box">
    <div class="log-data flex-center">
      <div class="log-data-num f-b ellipsis">
        {{info.data}}
        <span class="log-unit">
          {{info.unit?info.unit:null}}
        </span>
      </div>
    </div>
  <div class="log-data-name flex-center">
    {{info.name}}
  </div>
  </div>
</template>

<script>
  export default {
    props:['info']
  }
</script>

<style scoped>
.log-unit{
  font-size: 0.8vw;
}
.log-data-name{
  color: #04B0DB;
  font-size: 0.8vw;
  margin-top: 0.2vw;
}
.log-data-num{
  font-size: 0.8vw;
}
.log-data{
  max-width: 100%;
  align-items: baseline !important;
}
.log-data-box::before{
  top: 0;
}
.log-data-box::after{
  bottom: 0;
}
.log-data-box::before,.log-data-box::after{
  content: " ";
  display: block;
  position: absolute;
  width:100%;
  background: linear-gradient(to right ,transparent,#02B9E1,transparent);
  height: 0.16vw;
}
.log-data-box{
  position: relative;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 6.5vw;
  min-width: 6.5vw;
  padding: 0.8vw 0;
  background: linear-gradient(to right ,transparent ,#0f4274 50%, #0f4274 60%,transparent);
}
</style>
